import React from "react";
import { TextField, SxProps, Theme } from "@mui/material";
import { codeInputSx } from "./styles";

interface TwoFactorCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  onEnter?: () => void;
  /** Override or extend the default input styles */
  sx?: SxProps<Theme>;
  /** When true, shows a green validated border */
  validated?: boolean;
}

/**
 * Reusable 6-digit verification code input for 2FA flows.
 * Accepts only digits and limits to 6 characters.
 */
const TwoFactorCodeInput: React.FC<TwoFactorCodeInputProps> = ({
  value,
  onChange,
  disabled = false,
  autoFocus = false,
  onEnter,
  sx,
  validated = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value.replace(/\D/g, "").slice(0, 6));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && onEnter) {
      onEnter();
    }
  };

  const validatedOverrides = validated
    ? {
        "& .MuiOutlinedInput-root": {
          ...((codeInputSx as any)["& .MuiOutlinedInput-root"]),
          "& fieldset": { borderColor: "#4caf50", borderWidth: 2 },
          "&:hover fieldset": { borderColor: "#4caf50" },
          "&.Mui-focused fieldset": { borderColor: "#4caf50" },
        },
      }
    : {};

  return (
    <TextField
      fullWidth
      placeholder="● ● ● ● ● ●"
      value={value}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      disabled={disabled}
      autoFocus={autoFocus}
      inputProps={{ maxLength: 6 }}
      sx={{ ...codeInputSx, ...validatedOverrides, ...sx } as SxProps<Theme>}
    />
  );
};

export default TwoFactorCodeInput;
